<es-document-download
  [validationMessages]="validationMessages"
  [isCanUploadDocuments]="isCanUploadDocuments"
  [isCanRemoveDocuments]="isCanRemoveDocuments"
  [attachmentTypeName]="'ENTRY_SUMMARY.BILL_OF_LADING_DOCS.INVOICE.TITLE'"
  [id]="'upload-invoice-file-' + invoice.id"
  [document]="invoiceDoc"
  [upload]="upload"
  [remove]="remove"
  (stateUpdate)="onStateUpdate($event)"
></es-document-download>

<es-document-download
  *ngFor="let document of invoiceOtherDocs; let docIndex = index"
  [validationMessages]="validationMessages"
  [isCanUploadDocuments]="isCanUploadDocuments"
  [isCanRemoveDocuments]="isCanRemoveDocuments"
  [attachmentTypeName]="'DOCUMENT_TYPE.' + enumDocumentType[document.type]"
  [id]="'upload-line-item-other-file-' + invoice.id + '-' + index + '-' + docIndex"
  [document]="document"
  [upload]="upload"
  [remove]="remove"
  (stateUpdate)="onStateUpdate($event)"
></es-document-download>

<div *ngFor="let lineItem of invoice.lines; let index = index">
  <es-line-item-attach-document
    [validationMessages]="validationMessages"
    [isCanUploadDocuments]="isCanUploadDocuments"
    [isCanRemoveDocuments]="isCanRemoveDocuments"
    [attachedDocuments]="attachedDocuments"
    [entrySummaryId]="entrySummaryId"
    [index]="index"
    [lineItem]="lineItem"
    [isShowEmptyDocuments]="isShowEmptyLineItemDocuments"
    [upload]="upload"
    [remove]="remove"
    (stateUpdate)="onStateUpdate($event)"
  ></es-line-item-attach-document>
</div>
<document-add-other
  *ngIf="isCanLoadOther"
  [createDocument]="createDocumentTemplate"
  [includesTypes]="includesTypes"
  [upload]="upload"
></document-add-other>
